import { FullscreenModal } from '@tkww/orion-web-ds-dialog';
import { type ClassesRecord, compose } from '@xo-union/react-css-modules';
import React, { type FC, type MouseEvent } from 'react';
import SearchByLocation from '../../../../../components/shared/Search/Mobile/containers/ChangeSearchModal/SearchByLocation';
import Styles from './styles.scss';

const modalClasses = compose<string, ClassesRecord<string>>({
	container: Styles.semanticMobileContainer,
	content: Styles.semanticContent,
	header: Styles.semanticModalHeader,
	'tk-logo': Styles.tkLogo,
});

interface SemanticMobileModalProps {
	handleModalOnClose: (e: MouseEvent) => void;
}

export const SemanticMobileModal: FC<SemanticMobileModalProps> = (props) => {
	const { handleModalOnClose } = props;

	return (
		<FullscreenModal classes={modalClasses} onClose={handleModalOnClose}>
			<SearchByLocation title="Category & Location" />
		</FullscreenModal>
	);
};
